import { NavigationLink } from '../app/shared/interfaces/navigation-link';

export const departments: NavigationLink[] = [
    {label: 'Power Tools', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'Power Tools', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'Workbenches', url: './shop'},
                {label: 'Presses', url: './shop'},
                {label: 'Spray Guns', url: './shop'},
                {label: 'Riveters', url: './shop'}
            ]},
            {size: 3, items: [
                {label: 'Hand Tools', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Garden Equipment', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Machine Tools', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Instruments', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Hand Tools', url: './shop', menu: {
        type: 'megamenu',
        size: 'lg',
        image: 'assets/images/megamenu/megamenu-2.jpg',
        columns: [
            {size: 4, items: [
                {label: 'Hand Tools', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Garden Equipment', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 4, items: [
                {label: 'Machine Tools', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 4, items: [
                {label: 'Instruments', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Machine Tools', url: './shop', menu: {
        type: 'megamenu',
        size: 'nl',
        image: 'assets/images/megamenu/megamenu-3.jpg',
        columns: [
            {size: 6, items: [
                {label: 'Hand Tools', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Garden Equipment', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 6, items: [
                {label: 'Instruments', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Building Supplies', url: './shop', menu: {
        type: 'megamenu',
        size: 'sm',
        columns: [
            {size: 12, items: [
                {label: 'Hand Tools', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Garden Equipment', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Electrical', url: './shop', menu: {
        type: 'menu',
        items: [
            {label: 'Soldering Equipment', url: './shop', items: [
                {label: 'Soldering Station', url: './shop'},
                {label: 'Soldering Dryers', url: './shop'},
                {label: 'Gas Soldering Iron', url: './shop'},
                {label: 'Electric Soldering Iron', url: './shop'}
            ]},
            {label: 'Light Bulbs', url: './shop'},
            {label: 'Batteries', url: './shop'},
            {label: 'Light Fixtures', url: './shop'},
            {label: 'Warm Floor', url: './shop'},
            {label: 'Generators', url: './shop'},
            {label: 'UPS', url: './shop'}
        ]
    }},
    {label: 'Power Machinery',        url: './shop'},
    {label: 'Measurement',            url: './shop'},
    {label: 'Clothes & PPE',          url: './shop'},
    {label: 'Plumbing',               url: './shop'},
    {label: 'Storage & Organization', url: './shop'},
    {label: 'Welding & Soldering',    url: './shop'}
];
